import './PauseButton.css';
import pauseButtonImg from './pause_button.png';

type PauseButtonProps = {
  onClick?: () => void;
};

/** Pause control — 55 × 1680.0007, 195×200. */
export function PauseButton({ onClick }: PauseButtonProps) {
  return (
    <button
      type="button"
      className="pause-button"
      aria-label="Пауза"
      onClick={onClick}
    >
      <img
        className="pause-button__icon"
        src={pauseButtonImg}
        alt=""
        draggable={false}
        aria-hidden
      />
    </button>
  );
}
